import Vue from 'vue'
import App from '@/App.vue'

import vSelect from 'vue-select'
import Vue2TouchEvents from 'vue2-touch-events'

import store from '@/store'
import router from '@/router'

Vue.config.productionTip = false

import '@/assets/css/blk.css'
import '@/assets/css/style.scss'
import '@/assets/vendor/nucleo-icons.css'

Vue.component('v-select', vSelect)
Vue.use(Vue2TouchEvents)
Vue.mixin({
    methods: {
        noop () {}
    }
})
Vue.filter('pluralize', function(items){
    let val
    if (Number.isInteger(items)) {
        val = items
    } else {
        if(!items) return;
        val = items.length
    }
    return val===1?'':'s'
})

const vue = new Vue({
  router,
  store,
  render: h => h(App)
})

vue.$mount('#app')

vue.$store.dispatch('setTouchDevice', ('ontouchstart' in window))
